import ListSearchBar from "../ListSearchBar";
// ListeReports.tsx

import React, { useState } from 'react';
import { Row, Col, Button, InputGroup, FormControl } from 'react-bootstrap';
import { useTranslate } from '../../hooks/LanguageProvider';
import usePermissions from '../../hooks/usePermissions';


interface ListProps {
  selectedReports: number[];
  onReportsChange: (selectedReports: number[]) => void;
}

function ListReports({ selectedReports, onReportsChange }: ListProps) {

  const { translate } = useTranslate();

  const roleId = localStorage.getItem("id_role");


  const { userPermissions, loading } = usePermissions(roleId);


  function mapPermissionIdToReportId(permissionId: number): number | null {
    const mapping: Record<number, number> = {
      50: 1,
      51: 2,
      52: 3,
      53: 4,
      54: 5,
      55: 6,
      56: 7,
      57: 8,
      58: 10,
      59: 11,
      60: 12,
      61: 13,
      62: 14,
      63: 15,
      64: 16,
      65: 17,
      66: 18,
      67: 19,
      68: 20,
      69: 21,
      70: 25,
      71: 26,
      72: 27,
      73: 29,
      75: 31,
      76: 33,
      77: 34,
      78: 45,
      139: 9
    };
    return mapping[permissionId] ?? null;
  }

  // Données de base
  const allReportsData: { [key: number]: string } = {
    1: translate("Itinerary reconstitution"),
    2: translate("Proximity report"),
    3: translate("Alarms"),
    4: translate("Diagram of distance, speed and contact"),
    5: translate("Fuel Tank (IO) Diagram"),
    6: translate("Diagram of GSM and GPS signal"),
    7: translate("Engine diagram"),
    8: translate("CAN Distance and Consumption Diagram"),
    9: translate("Distance consumption diagram"),
    10: translate("Contact Report"),
    11: translate("[CAN] RPM statistics"),
    12: translate("[CAN] Speed statistics"),
    13: translate("Speed statistics"),
    14: translate("Gantt chart on proximity"),
    15: translate("Gantt chart on contact"),
    16: translate("System state diagram"),
    17: translate("Mobile traffic"),
    18: translate("Fuel tank diagram"),
    19: translate("[RHT] Temperature diagram"),
    20: translate("[FFS] Distance and consumption diagram"),
    21: translate("[TCO] Tachograph diagrams"),
    25: translate("Speeding violation report"),
    26: translate("[QHSE] QHSE"),
    27: translate("Driver behavior report"),
    29: translate("Work amplitude report"),
   // 30: translate("Fleet report"),
    31: translate("Fleet report [CAN]"),
    33: translate("HOS Hour of Service (PSN)"),
    34: translate("Trip report"),
    45: translate("Rapport CO2/Kg"),
  };



  const reportsData: { [key: number]: string } = Object.fromEntries(
    userPermissions
      .map((perm) => mapPermissionIdToReportId(perm.id_permission)) // ✅ corrige ici
      .filter((id): id is number => id !== null)
      .map((id) => [id, allReportsData[id]])
  );


  const [searchTerm, setSearchTerm] = useState('');
  const [isGridView, setIsGridView] = useState(true);

  const handleCheckboxChange = (reportNumber: number) => {
    const updatedSelection = selectedReports.includes(reportNumber)
      ? selectedReports.filter((selected) => selected !== reportNumber)
      : [...selectedReports, reportNumber];

    onReportsChange(updatedSelection);
  };

  const handleSelectAll = () => {
    const allReportNumbers = Object.keys(reportsData).map(Number);
    const updatedSelection = selectedReports.length === allReportNumbers.length
      ? []  // Désélectionner tous si tous sont déjà sélectionnés
      : allReportNumbers;

    onReportsChange(updatedSelection);
  };

  const reportsArray = Object.values(reportsData);
  const filteredReports = Object.keys(reportsData).filter((reportNumber) =>
    translate(reportsData[Number(reportNumber)]).toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (

    <div style={{ padding: "15px 15px" }} >
      <Row>
        <Col xs={12} md={6} className='p-0'>
          <ListSearchBar onReset={()=>setSearchTerm("")} resetLabel={translate("Reset search")}><FormControl
              type="text"
              placeholder={translate("Search for a report")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            /></ListSearchBar>
        </Col>
        <Col xs={12} md={6} className="text-right">
          <Button onClick={() => setIsGridView(!isGridView)} style={{ background: "no-repeat", color: "#000", border: "1px solid #ddd" }} className={` ${isGridView ? 'active' : ''}`} >
            {isGridView ? (
              <>
                <i className="las la-icons" style={{ fontSize: "21px" }} ></i>
                <span>{translate("Grid View")}</span>
              </>
            ) : (
              <>
                <i className="las la-list" style={{ fontSize: "21px" }} ></i>
                <span> {translate("List view")}</span>
              </>
            )}
          </Button>

        </Col>
      </Row>

      <div style={{ padding: "5px 0px", borderBottom: "0px" }}>
        <input
          id="reports_cb"
          name="allRep"
          type="checkbox"
          onChange={handleSelectAll}
          checked={selectedReports.length === Object.keys(reportsData).length}
        />
        <label htmlFor="reports_cb"></label>
        <strong> {translate("Reports")} </strong>
      </div>

      {loading ? (
        <div style={{ padding: "20px", textAlign: "center" }}>{translate("Loading...")}</div>
      ) : filteredReports.length === 0 ? (
        <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
          {translate("No reports available")}
        </div>
      ) : isGridView ? (
        <Row style={{ padding: "15px 0", overflowY: "scroll", maxHeight: "55vh" }}>
          {filteredReports
            .filter((reportNumber) =>
              translate(reportsData[Number(reportNumber)])
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            )
            .map((reportNumber) => (
              <Col
                style={{ padding: "15px 15px 15px 0px" }}
                key={reportNumber}
                xs={12}
                sm={6}
                md={3}
                lg={3}
              >
                <div
                  className={`grid-item${selectedReports.includes(Number(reportNumber)) ? ' selected-grid-item' : ''
                    }`}
                  onClick={() => handleCheckboxChange(Number(reportNumber))}
                  style={{
                    border: '1px solid #DDD',
                    borderRadius: '5px',
                    padding: '10px',
                    cursor: 'pointer',
                  }}
                >
                  <i className={`las la-${reportsData[Number(reportNumber)]}`} style={{ fontSize: "28px" }}></i>
                  <img
                    src={`asset/images/icon-report/${reportNumber}.png`}
                    alt={`${reportNumber}`}
                    style={{ width: "32px", marginRight: "5px" }}
                  />
                  [{reportNumber}] {reportsData[Number(reportNumber)]}
                </div>
              </Col>
            ))}
        </Row>
      ) : (
        <div className="list-container">
          {filteredReports
            .filter((reportNumber) =>
              translate(reportsData[Number(reportNumber)])
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            )
            .map((reportNumber) => (
              <div
                key={reportNumber}
                className={`list-item${selectedReports.includes(Number(reportNumber)) ? ' selected' : ''
                  }`}
                onClick={() => handleCheckboxChange(Number(reportNumber))}
                style={{ cursor: 'pointer', paddingBottom: "5px" }}
              >
                <input
                  type="checkbox"
                  value={reportNumber}
                  checked={selectedReports.includes(Number(reportNumber))}
                  onChange={() => handleCheckboxChange(Number(reportNumber))}
                  style={{ marginRight: "5px" }}
                />
                [{reportNumber}] {reportsData[Number(reportNumber)]}
              </div>
            ))}
        </div>
      )}

    </div>

  );
}

export default ListReports;

export { };
